import { TReduxActions } from '../../types/redux';
import { PlainLocationDescriptor } from '../../utils/location';
import { ELocationActionTypes } from '../../actions/location';

export const locationInitialValue = { query: '', hash: '' };

export function locationReducer(state: PlainLocationDescriptor = locationInitialValue, action: TReduxActions) {
  if (action.type === ELocationActionTypes.ChangeLocation) {
    return {
      query: action.payload.query,
      hash: action.payload.hash,
    };
  }

  return state;
}
